import useTranslation from '@space-core/hooks/useTranslation'
import clsx from 'clsx'
import '@hotmart/cosmos/dist/styles/utilities/text/variations/red.css'

import { Card, Text, WrapperContent } from '../styles'
import type { ContentSearchProps } from '../types'

const Content = ({ products, className, onClick }: ContentSearchProps) => {
  const { t } = useTranslation()

  const wrapperClass = clsx('_cursor-pointer _my-0 _mx-auto', className)
  const boxClass = clsx(
    '_my-0 _mx-auto _px-0 _py-4 _border-bottom _align-items-end _justify-content-between ',
    className
  )

  const selectEntityType = (productEntityType: string) => {
    const entityType = {
      POST: t('global_search.entity_type.post'),
      COMMUNITY: t('global_search.entity_type.community'),
      MEMBERSHIP: t('global_search.entity_type.membership'),
      MODULE: t('global_search.entity_type.module'),
      PAGE: t('global_search.entity_type.page')
    }

    return productEntityType ? entityType[productEntityType] : null
  }

  return (
    <>
      {products?.map((product, index) => (
        <WrapperContent
          key={index}
          className={wrapperClass}
          onClick={() => onClick(product)}
          data-test={`content-modal-search-${product.id}`}>
          <Card className={boxClass}>
            <span>
              <p className='_font-14 _text-left _text-gray-900 _mb-1'>
                {selectEntityType(product.entityType)}
              </p>
              <Text
                className='_text-2 _text-left _font-weight-bold _line-height-lg _mb-2 _w-full content'
                data-test='content-search-name'>
                {product.name}
              </Text>

              <Text
                className='_font-14 _text-left _text-gray-600 _line-height _m-0 _w-full content'
                data-test='content-search-description'>
                {product.description}
              </Text>
            </span>
          </Card>
        </WrapperContent>
      ))}
    </>
  )
}

export default Content
